/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import { useTranslation } from 'react-i18next'
import Button from '@/shared/components/Button/Button'
import styles from './Dropzone.module.scss'

type DropzoneSize = {
  width: number
  height: number
}

interface DropzoneProps {
  field?: any
  onImageDrop: (file: File) => void
  color?: 'light' | 'dark'
  size: DropzoneSize
}

function Dropzone(props: DropzoneProps) {
  const { field, onImageDrop, color = 'light', size } = props
  const { t } = useTranslation()

  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      const file = acceptedFiles[0]
      if (file) {
        const reader = new FileReader()
        reader.readAsDataURL(file)

        onImageDrop(file)
      }
    },
    [onImageDrop]
  )

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { 'image/*': [] }
  })

  return (
    <div
      className={`dropzoneContainer ${styles.dropzoneContainer} ${
        isDragActive ? styles.dropzoneActive : ''
      } ${color === 'light' ? styles.light : ''}`}
      style={{ height: size.height, width: size.width }}
    >
      <div {...field} className={styles.dropzoneArea}>
        <input {...getInputProps()} />
        <div className={styles.dropzone} {...getRootProps()}>
          <p className={`${styles.dropzoneText} title-bold-large`}>
            {t('DROPZONE.FIRST_PART')}{' '}
            {isDragActive ? (
              <mark className="mark-orange">{t('DROPZONE.SECOND_PART')}</mark>
            ) : (
              t('DROPZONE.SECOND_PART')
            )}
            {t('DROPZONE.THIRD_PART')}
            <mark className="mark-orange">{t('DROPZONE.FOURTH_PART')}</mark>
          </p>
          <p className={`${styles.dropzoneText} title-bold-large`}>
            {t('DROPZONE.FIFTH_PART')}
          </p>
          <Button
            label={t('DROPZONE.BUTTON')}
            variant="contained"
            color="secondary"
            onClick={() => null}
          />
          <p className={`${styles.dropzoneInfo} body-small`}>
            {t('DROPZONE.IMAGE_INFO.FIRST_PART')}
          </p>
          <p className={`${styles.dropzoneInfo} body-small`}>
            {t('DROPZONE.IMAGE_INFO.SECOND_PART')}
          </p>
        </div>
      </div>
    </div>
  )
}

export default Dropzone
